import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

export default function rootRender(id: string, children: React.ReactNode) {
  const rootElement = document.getElementById(id);
  if (!rootElement) return;

  const root = createRoot(rootElement);
  root.render(
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      {children}
    </ErrorBoundary>
  );
}
